import React, { useState } from "react";

import { useGetDataInfoRange } from "api/api-hooks/datasets-hooks";
import { T } from "services/lang/LanguageService";
import CalendarWrapper from "components/basic/calendar-wrapper/CalendarWrapper";
import { IGridHeatmapEditorProps } from "./grid-heatmap-editor/GridHeatmapEditor";
import GridHeatmapChart from "./GridHeatmapChart";
import { defaultFromDateTime, defaultToDateTime, shouldShowTime } from "../charts/utils";

const GridHeatmap = (props: IGridHeatmapEditorProps) => {
  const [dateFrom, setDateFrom] = useState(
    props.start ||
      defaultFromDateTime({
        loadConf: {
          alignUnit: "MINUTES",
          lag: 6,
          lagUnit: "HOURS",
          lead: 0,
          leadUnit: "HOURS",
          ...props.loadConf,
        },
      })
  );

  const [dateTo, setDateTo] = useState(
    props.end ||
      defaultToDateTime({
        loadConf: {
          alignUnit: "MINUTES",
          lag: 6,
          lagUnit: "HOURS",
          lead: 0,
          leadUnit: "HOURS",
          ...props.loadConf,
        },
      })
  );

  const { data } = useGetDataInfoRange(
    props.yAxisSecondary?.identifier
      ? [props.xAxis.identifier, props.yAxis.identifier, props.yAxisSecondary?.identifier]
      : [props.xAxis.identifier, props.yAxis.identifier],
    {
      timeStart: dateFrom?.toISOString() ?? new Date().toISOString(),
      timeEnd: dateTo?.toISOString(),
    }
  );
  return (
    <div>
      <div className="flex flex-row gap-3">
        <div className="flex flex-column gap-2">
          <b style={{ padding: "0 0 0 5px" }}>{T("word.from")}</b>
          <CalendarWrapper
            value={dateFrom}
            showTime={shouldShowTime(props.loadConf)}
            onChange={e => {
              setDateFrom(e);
            }}
            dateFormat="yy-mm-dd"
          />
        </div>
        <div className="flex flex-column gap-2">
          <b style={{ padding: "0 0 0 5px" }}>{T("word.to")}</b>
          <CalendarWrapper
            value={dateTo}
            showTime={shouldShowTime(props.loadConf)}
            onChange={e => {
              setDateTo(e);
            }}
            dateFormat="yy-mm-dd"
          />
        </div>
      </div>
      {data && <GridHeatmapChart data={data} {...props} />}
    </div>
  );
};

export default GridHeatmap;
